import * as React from "react";
import { useTranslation } from "react-i18next";
import useStyles from "./LoadingEllipsis.styles";

interface LoadingEllipsisProps {
    duration?: number;
    text?: string;
}

export default function LoadingEllipsis({ duration = 1000, text }: LoadingEllipsisProps) {
    const classes = useStyles({});
    const [count, setCount] = React.useState(0);
    const { t } = useTranslation();

    React.useEffect(() => {
        const onTick = () => setCount((e) => (e + 1) % 3);
        const interval = window.setInterval(onTick, duration / 3);
        return () => window.clearInterval(interval);
    }, [duration]);

    return (
        <div className={classes.loading}>
            {text || t("common.loading")}
            <span
                style={{
                    display: "inline-block",
                    width: "2ch",
                    textAlign: "left",
                    marginRight: "-2ch",
                }}
            >
                {".".repeat(count + 1)}
            </span>
        </div>
    );
}
